var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-input "},[_c('input',_vm._g(_vm._b({staticClass:"my-input__inner",attrs:{"autocomplete":"off"},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.$listeners))])}
var staticRenderFns = []

export { render, staticRenderFns }